import React from "react";

import { QRFRameProps } from "../types";

import { getPreviewFrameFontSize } from "@/utils/qrEditorHelper";

import "../styles.scss";

export const likeFrame = (
  props: Omit<QRFRameProps, "frameType">
): React.SVGProps<SVGSVGElement> => {
  const { text, textColor, children, frameColor, frameBackgroundColor, urlQr } = props;

  const fontSize = getPreviewFrameFontSize(text?.length);

  return (
    <svg
      width="96"
      height="128"
      viewBox="0 0 96 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.5"
        y="0.5"
        width="95"
        height="127"
        rx="7.5"
        fill="white"
      />
      <rect
        x="0.5"
        y="0.5"
        width="95"
        height="127"
        rx="7.5"
        stroke="#BFBFBF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M58.1017 35.0529H58.0808C58.5268 35.3381 58.8226 35.8333 58.8226 36.3978C58.8226 37.1874 58.2446 37.8419 57.4849 37.9733C57.4707 37.9884 57.4584 38.0046 57.4453 38.0203C57.5871 38.2584 57.6699 38.5349 57.6699 38.8313C57.6699 39.7155 56.9458 40.4323 56.0525 40.4323H46.8638C46.3279 40.4323 45.7724 40.1873 45.2356 39.7797V30.9297C46.1048 30.3957 46.9604 29.9324 47.5517 29.0333C49.11 26.6638 49.7197 25.8402 51.7783 22.8855C52.3108 22.1212 52.3264 20.475 52.931 20.3239C53.0456 20.2953 53.1532 20.2808 53.2532 20.2808C53.936 20.2808 54.2756 20.9529 54.2118 22.3732C54.1386 24.0016 53.3366 26.1728 53.0591 26.8559C52.7816 27.539 52.4465 28.2961 52.6748 28.649C52.814 28.8643 53.0162 28.9663 53.3088 29.0333H57.8127C58.6534 29.0333 59.3349 29.7214 59.3349 30.5702C59.3349 31.1496 59.0166 31.6524 58.5476 31.914C59.2238 32.1058 59.7192 32.721 59.7192 33.452C59.7192 34.3362 58.9951 35.0529 58.1017 35.0529ZM43.9655 40.8165C43.9655 41.2409 43.6214 41.585 43.1971 41.585H37.0493C36.6249 41.585 36.2808 41.2409 36.2808 40.8165V29.8017C36.2808 29.3773 36.6249 29.0333 37.0493 29.0333H43.1971C43.6214 29.0333 43.9655 29.3773 43.9655 29.8017V40.8165ZM61 33.452C61 32.797 60.7735 32.1789 60.3864 31.6844C60.5353 31.338 60.6158 30.9598 60.6158 30.5702C60.6158 29.0165 59.3583 27.7525 57.8127 27.7525H54.0777C54.1177 27.6515 54.1574 27.5541 54.1906 27.473L54.2457 27.3379C54.4382 26.8642 55.4027 24.401 55.4913 22.4307C55.5507 21.1093 55.3158 20.2194 54.7521 19.6298C54.3639 19.2237 53.8315 19 53.2532 19C53.0492 19 52.8363 19.0274 52.6204 19.0813C51.5472 19.3496 51.2492 20.4532 51.0317 21.259C50.9513 21.5565 50.8299 22.0061 50.7274 22.1533C50.2225 22.8781 49.8048 23.4744 49.439 23.9968C48.2967 25.6279 47.6674 26.5264 46.4816 28.3295C46.1772 28.7924 45.7477 29.1066 45.2145 29.4407C45.0434 28.4824 44.2038 27.7525 43.1971 27.7525H37.0493C35.9193 27.7525 35 28.6718 35 29.8017V40.8165C35 41.9465 35.9193 42.8658 37.0493 42.8658H43.1971C44.1705 42.8658 44.9875 42.1835 45.1953 41.2721C45.7519 41.5651 46.3105 41.7131 46.8637 41.7131H56.0525C57.6506 41.7131 58.9508 40.4203 58.9508 38.8313C58.9508 38.788 58.9497 38.7448 58.9477 38.7016C59.6565 38.1726 60.1034 37.3318 60.1034 36.3978C60.1034 36.1339 60.0676 35.8756 59.9991 35.6287C60.6119 35.0999 61 34.3202 61 33.452Z"
        fill={frameColor}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M41.2815 37.9007C40.7686 37.9007 40.3529 38.3165 40.3529 38.8293C40.3529 39.3422 40.7686 39.7579 41.2815 39.7579C41.7943 39.7579 42.2101 39.3422 42.2101 38.8293C42.2101 38.3165 41.7943 37.9007 41.2815 37.9007Z"
        fill={frameColor}
      />
      <rect
        x="23"
        y="46"
        width="50"
        height="50"
        rx="2"
        fill={frameBackgroundColor}
      />

      <foreignObject
        width="46%"
        height="44px"
        style={{ borderRadius: "3px" }}
        x="26"
        y="49">
        <div
          id="#qrCode"
          style={{
            border: `1px solid ${frameBackgroundColor || "white"}`,
            width: "100%",
            height: "100%",
            boxSizing: "border-box",
            backgroundColor: `${frameBackgroundColor}`,
          }}>
          {urlQr ? (
            <img
              src={urlQr}
              width="100%"
              height="auto"
            />
          ) : (
            children
          )}
        </div>
      </foreignObject>
      <foreignObject
        width="100%"
        height="18px"
        y="95">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style={{ width: "100%", height: "100%", maxWidth: "100%" }}>
          <text
            x="50%"
            y="11"
            fill={textColor}
            dominantBaseline="middle"
            textAnchor="middle"
            fontFamily="sans-serif"
            fontWeight="bold"
            style={{ fontSize }}>
            {text}
          </text>
        </svg>
      </foreignObject>
    </svg>
  );
};
